export default __webpack_public_path__ + "static/media/Steel City-6.72a0a0e2.jpg";